import { useContext } from 'react';

import { ToastContext, ToastProps } from '@/store/ToastContextProvider';

export default function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error('can not found toast provider');

  const open = (toast: Omit<ToastProps, 'onClose'>) => {
    context.addToast(toast);
  };

  const close = () => {
    context.removeToast();
  };

  return { open, close, list: context.toast };
}
